/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
ACC.countryProductAvailability = {
    _autoload: ['init'],

    init() {
        /**
         * DMCP is a global geolocation object
         * If DMCP doent exist, return from countryProductAvailability property
         */
        try {
            // eslint-disable-next-line no-unused-expressions
            DMCP;
        } catch (e) {
            if (e.name === 'ReferenceError') {
                return;
            }
        }
        DMCP.Geolocation.trackUserLocale();
        const config = this.initConfig();
        this.checkLocale(config);
    },

    initConfig() {
        return {
            checkingLocales: ['CA', 'US', 'GB', 'AU', 'NZ'],
            // eslint-disable-next-line no-underscore-dangle
            userLocale: DMCP.Geolocation._config.userLocale,
        };
    },

    // eslint-disable-next-line consistent-return
    checkLocale(config) {
        if (config.userLocale === 'NA') {
            return DMCP.Geolocation.akamaiResponse.always(() => {
                // eslint-disable-next-line no-underscore-dangle
                config.userLocale = DMCP.Geolocation._config.userLocale;
                ACC.countryProductAvailability.createModalPopup(config.checkingLocales, config.userLocale);
            });
        }

        ACC.countryProductAvailability.createModalPopup(config.checkingLocales, config.userLocale);
    },

    createModalPopup(locales, userLocale) {
        if (locales.indexOf(userLocale) >= 0) {
            return;
        }

        DMCP.Geolocation.createModal('selectYourStore', 'Student', false);
    },
};
